import styled from '@emotion/styled';

export const SContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  .custom-ant-typography {
    .ant-typography-copy,
    .ant-typography-link {
      color: rgba(0, 0, 0, 0.45);
      &:hover,
      &:active {
        color: #000000;
      }
    }
  }
`;
